export default {
  'INDICATIONREWARD' (state) {
    return state.indicationreward
  },
  'INDICATIONREWARDS' (state) {
    return state.indicationrewards
  }
}
